export default "__VITE_ASSET__Cg$nLFse__"